
























































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CovidModal extends Vue {
  @Prop() value!: boolean;
  @Prop({ default: () => ({}) }) covid!: any;
}
